import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import Table from "../../../components/common/Table"
import { IUserJobSearch } from "../../../models"
import { green500 } from "material-ui/styles/colors"

interface IProps {
	readonly: boolean
	jobs: IUserJobSearch[]
	selectedJobs: IUserJobSearch[]
	total: number
	offset: number
	limit: number
	limitOptions: number[]
	milesFilter: boolean
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleClickRow(jobId: string): void
	handleSelectJobs(jobs: IUserJobSearch[]): void
}

const UserDetailsJobsTable: React.SFC<IProps> = (props: IProps) => {
	return (
		<Table
			readonly={props.readonly}
			allowClickRow
			items={props.jobs}
			handleSelect={props.handleSelectJobs}
			handleClickRow={job => props.handleClickRow(job.Id)}
			total={props.total}
			offset={props.offset}
			limit={props.limit}
			limitOptions={props.limitOptions}
			onPageClick={props.onPageClick}
			onLimitChange={props.onLimitChange}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={{ textAlign: "left", width: 150, paddingLeft: 5, paddingRight: 5 }}>{strings.Name}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Status}</TableHeaderColumn>
					{props.milesFilter && <TableHeaderColumn style={{ textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>{strings.Distance_To_Job}</TableHeaderColumn>}
					<TableHeaderColumn style={{ textAlign: "center", width: 80, paddingLeft: 5, paddingRight: 5 }}>{strings.Active}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody deselectOnClickaway={false}>
				{props.jobs.map((job, i) => {
					const status = job.Available ? strings.Available : job.ConfirmedWork ? strings.Confirmed_Work : job.Requested ? strings.Requested : ""
					const distance = job.Distance !== -1 ? `${job.Distance} ${strings.Miles.toLowerCase()}` : "-"
					return (
						<TableRow data-intercom-target={i === 0 && "menu-Employees-Jobs-openEmployeeJobDetails"} key={job.Id} selected={props.selectedJobs.find(item => item.Id === job.Id) ? true : false}>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: 150, paddingLeft: 5, paddingRight: 5 }} title={job.JobName}>
								{job.JobName}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }} title={status}>
								{status}
							</TableRowColumn>
							{props.milesFilter &&
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", paddingLeft: 5, paddingRight: 5 }} title={distance}>
									{distance}
								</TableRowColumn>
							}
							<TableRowColumn style={{ textAlign: "center", cursor: "pointer", width: 80, paddingLeft: 5, paddingRight: 5 }}>
								{job.Active &&
									<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
								}
							</TableRowColumn>
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default UserDetailsJobsTable